module.exports = __webpack_public_path__ + "img/1_8.b3de89c1.png";